import { homeInfo, checkWeChatBind, unBindWeChatRequest } from '@/assets/request/HomeRequest';
import {GET_USERINFO} from "../mutation-types";
import Vue from "vue";
import {Message} from "element-ui";

export default {
    state:{
        loginName:'',
        userName:'',
        companyName:'',
        userType:'',
        userPhone:'',
        userDailyLimit:null,
        pending:{},
        weChatInfo:{},
        // login: true, /* 是否登录 */
    },
    mutations:{
        //获取用户信息存入vuex
        [GET_USERINFO](state, {loginName, userName, companyName, userType, userPhone,userDailyLimit,pending,weChatsInfo}) {
            state.loginName = loginName;
            state.userName = userName;
            state.companyName = companyName;
            Vue.set(state,'userType',userType)
            state.userPhone = userPhone;
            state.userDailyLimit = userDailyLimit;
            state.pending = pending;
            state.weChatInfo = weChatsInfo;
        },
        unBindWeChatMutation(state){
            state.weChatInfo={}
        },
    },
    actions:{
        async getUserInfoAction({commit}) {
            let res = await homeInfo().catch(r=>{
                const tip = '获取首页信息异常';
                Message.error(tip);
                console.trace({
                    message:tip,
                    r
                });
            });
            if(res.status!==200) return Message.warning(res.statusText);
            const {data} = res;
            if(Number(data.status)!==1) {
                if(data.info==='需要完善信息!') location.hash='/register';
                return Message.warning(data.info);
            }
            const commitData = {
                userName:data.data.curUser.f_manager_name,
                loginName:data.data.loginUser.fName,
                companyName:data.data.curUser.f_Name,
                userType:data.data.loginUser.fType,
                userDailyLimit:data.data['userDailyLimit'.toLowerCase()],
                pending:data.data.pending,
            };
            const weChatInfo = await checkWeChatBind().catch(r=>{
                const tip = '获取微信绑定信息异常';
                Message.error(tip);
                console.trace({
                    message:tip,
                    r
                });
            });
            if(weChatInfo.status===200){
                commitData.weChatsInfo=weChatInfo.data;
            }
            commit(GET_USERINFO, commitData);
        },
        async unBindWeChatAction({commit,dispatch}){
            const info = await unBindWeChatRequest().catch(r=>{
                const tip = '解除绑定异常';
                Message.error(tip);
                console.trace({
                    message:tip,
                    r
                });
            });
            if(info.status!==200) return Message.warning(info.statusText);
            const { data } = info;
            if(data.code==1){
                Message.success('成功解除绑定');
                dispatch('getUserInfoAction')
            }
            else{
                Message.warning('解除绑定失败，请联系管理员');
            }
        }
    },
    getters:{
        getUserInfoGetter(state){
            return state
        }
    }
}